// Memoized result of localStorage availability check
let isAvailable: boolean | null = null

export function isLocalStorageAvailable(): boolean {
  // Return memoized result if already checked
  if (isAvailable !== null) {
    return isAvailable
  }

  // Always return false on server-side
  if (process.server) {
    isAvailable = false
    return false
  }

  try {
    // Check if localStorage is defined
    if (typeof window === 'undefined' || !window.localStorage) {
      isAvailable = false
      return false
    }

    const testKey = '__storage_test__'

    // Test writing to localStorage
    localStorage.setItem(testKey, testKey)

    // Test reading from localStorage
    const result = localStorage.getItem(testKey)

    // Verify read value matches written value
    if (result !== testKey) {
      isAvailable = false
      return false
    }

    // Clean up test
    localStorage.removeItem(testKey)

    // Cache and return positive result
    isAvailable = true
    return true
  } catch (e) {
    // Handle specific error cases
    isAvailable = false

    // Log error in development
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        'localStorage is not available:',
        e instanceof Error ? e.message : 'Unknown error',
      )
    }

    return false
  }
}
